/**
 * MRM Translation Debug Tracker
 * Monitors variant changes, section loads, and fetch requests to diagnose translation issues
 */

// 🧩 DEBUG MRM Variant Translation Tracker
document.addEventListener('shopify:section:load', (e) => {
  console.groupCollapsed('🧩 Section Reload Detected');
  console.log('Section:', e.detail?.sectionId || 'unknown');
  console.log('URL actual:', window.location.href);
  console.log('Lang:', document.documentElement.lang);
  console.log('Button text post-render:', document.querySelector('button[name="add"]')?.textContent);
  console.log('Button with data-add-to-cart:', document.querySelector('[data-add-to-cart] .mm-buy-buttons__add-text')?.textContent);
  console.groupEnd();
});

document.addEventListener('shopify:variant:change', (e) => {
  console.groupCollapsed('🔄 Variant Change Detected');
  const variant = e.detail?.variant || {};
  console.log('Variant:', variant);
  console.log('URL:', window.location.href);
  console.log('Lang:', document.documentElement.lang);
  console.log('Form data-product-url:', document.querySelector('product-form')?.dataset?.productUrl);
  console.log('Form [data-product-form]:', document.querySelector('[data-product-form]')?.dataset?.productUrl);
  console.log('Add to Cart text before fetch:', document.querySelector('button[name="add"]')?.textContent);
  console.log('Add to Cart [data-add-to-cart]:', document.querySelector('[data-add-to-cart] .mm-buy-buttons__add-text')?.textContent);
  console.groupEnd();
});

document.addEventListener('mm:variant:change', (e) => {
  console.groupCollapsed('🎯 Custom MM Variant Change');
  console.log('Event detail:', e.detail);
  console.log('Button text:', document.querySelector('[data-add-to-cart] .mm-buy-buttons__add-text')?.textContent);
  console.groupEnd();
});

// Monitor fetch requests for section rendering
(function monitorFetch() {
  const origFetch = window.fetch;
  window.fetch = async (...args) => {
    const url = args[0];
    if (typeof url === 'string' && url.includes('section_id')) {
      console.groupCollapsed('📡 FETCH sección detectado');
      console.log('URL solicitada:', url);
      console.log('Lang actual:', document.documentElement.lang);
      console.log('¿Incluye /es/ ?', url.includes('/es/'));
      console.log('Full URL:', url);
      console.groupEnd();
    }
    const res = await origFetch(...args);
    return res;
  };
})();

// Monitor MutationObserver activity
console.log('🔍 MRM Translation Debug Loaded');
console.log('Initial button text:', document.querySelector('[data-add-to-cart] .mm-buy-buttons__add-text')?.textContent);
console.log('Initial lang:', document.documentElement.lang);
console.log('Initial product URL:', document.querySelector('[data-product-form]')?.dataset?.productUrl);
